"use strict";
/**
 * @fileoverview Article model for REST API
 * Represents the REST API version of article data
 * No ObjectIds to transform, but uses Material model
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRsdPrice = getRsdPrice;
exports.getEurPrice = getEurPrice;
exports.getArticleRsdPrice = getArticleRsdPrice;
/** Returns the RSD price amount from a prices array. Returns 0 if not found. */
function getRsdPrice(prices) {
    var _a, _b;
    return (_b = (_a = prices.find(p => p.currency === 'RSD')) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : 0;
}
/** Returns the EUR price amount from a prices array, or undefined if not priced in EUR. */
function getEurPrice(prices) {
    var _a;
    return (_a = prices.find(p => p.currency === 'EUR')) === null || _a === void 0 ? void 0 : _a.amount;
}
/**
 * Backward-compatible RSD price accessor.
 * Tries prices[] first; falls back to legacy scalar `price` field for old MongoDB documents.
 */
function getArticleRsdPrice(article) {
    var _a;
    if (article.prices && article.prices.length > 0) {
        return getRsdPrice(article.prices);
    }
    return (_a = article.price) !== null && _a !== void 0 ? _a : 0;
}
